//최대 행 갯수.
const maximum_row_num = 6;
// <tr><td>2021/4/23(금)</td><td>9ZIBEM3GFXOJYY2L</td></tr>

/*
* addRow 클로저
* init(테이블 클래스명).메소드()로 사용.
* data를 받아 왔을 경우 : addRow.init(테이블 클래스명).makeRow(데이터 오브젝트);
* */
export let addRow = (() => {
    let tr_list = [];
    let table_body;
    return {
        //table_body 지정 후 체이닝 가능하도록 반환
        init : function (table_name){
            table_body = document.querySelector(`.p-${table_name}`).querySelector('tbody');
            return this;
        },
        //초기 설정 빈 쿠폰 상태.
        emptyRow : function(){
            table_body.outerHTML = '<tbody><tr><td class="p-mycoupons--empty" rowspan="6">내역이 없습니다.</td></tr></tbody>'
        },
        //쿠폰 데이터를 통해 다시 그림.
        makeRow : async function(data){
            tr_list = []; //초기화.
            tr_list = data.reduce((pre,ele)=>{
                pre.push(`<tr><td>${ele.date}</td><td>${ele.couponKey}</td></tr>`);
                return pre;
            },[]);
            addRow.fillRow();
        },
        //빈칸 채우기
        fillRow : function(){
            while(tr_list.length < maximum_row_num){
                tr_list.push('<tr><td></td><td></td></tr>');
            }
            table_body.outerHTML = `<tbody>${tr_list.join('')}</tbody>`;
        }
    };
})();


// WEBPACK FOOTER //
// ./src/js/func/get_coupons.js